var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Treeselect', {
    class: {
      invalid: _vm.errors.length > 0
    },
    attrs: {
      "disabled": _vm.disabled,
      "options": _vm.options,
      "clearable": !_vm.noClearable,
      "default-expand-level": 1,
      "normalizer": _vm.normalizer,
      "placeholder": _vm.$t(_vm.placeholder),
      "noOptionsText": _vm.$t('ar_client_no_data'),
      "noResultsText": _vm.$t('ar_client_no_data'),
      "multiple": _vm.multiple,
      "limit-text": _vm.fnCount,
      "limit": 1,
      "clear-on-select": false
    },
    on: {
      "input": function ($event) {
        _vm.$emit('change', _vm.options.find(function (opt) {
          return opt[_vm.customReduce || 'Id'] === _vm.currentValue;
        }));
      }
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  }, [_vm.multiple ? _c('template', {
    slot: "before-list"
  }, [_c('label', {
    staticClass: "text-primary cursor-pointer",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.onSelectAll
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_client_select_all")) + " ")])]) : _vm._e(), _vm.loading ? _c('treeselect-tip', {
    attrs: {
      "slot": "after-list",
      "type": "loading",
      "icon": "loader"
    },
    slot: "after-list"
  }, [_vm._v(_vm._s(_vm.$t("ar_client_loading")) + "...")]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }